import type { BonusType } from '../types';

// Letter pool configuration
export const LETTER_POOL_SIZE = 150; // Easily tunable during playtesting
export const MAX_HAND_SIZE = 10; // Letters per player
export const BOWLING_PINS_COUNT = 15; // Balls per rack

// Board configuration
export const BOARD_SIZE = 21; // 21x21 grid (fixed)
export const CENTER_POSITION = { row: 10, col: 10 }; // Middle of board

// Bonus square generation
export const BONUS_SQUARE_MIN_DISTANCE = 3; // Minimum cells between bonuses
export const BONUS_SQUARE_TARGET_COUNT = 50; // ~11% of 441 cells

export const BONUS_DISTRIBUTION: Record<BonusType, number> = {
  DL: 0.40, // Double Letter: 40%
  DW: 0.30, // Double Word: 30%
  TL: 0.20, // Triple Letter: 20%
  TW: 0.10, // Triple Word: 10%
};

// Scoring multipliers
export const BONUS_MULTIPLIERS: Record<BonusType, number> = {
  DL: 2, // Double letter score
  TL: 3, // Triple letter score
  DW: 2, // Double word score
  TW: 3, // Triple word score
};
